// extracted by mini-css-extract-plugin
module.exports = {"flag":"flag--cQw4y"};